import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect, computed, defineProps, defineEmits } from "../../../adapter-vue";
import {
  TUIGlobal,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../Icon.vue";
import selectedIcon from "../../../assets/icon/selected.svg";
import backIcon from "../../../assets/icon/back.svg";
import cancelIcon from "../../../assets/icon/cancel.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  list: {
    type: Array,
    default: () => [],
  },
  selectedList: {
    type: Array,
    default: () => [],
  },
  isSearch: {
    type: Boolean,
    default: true,
  },
  isRadio: {
    type: Boolean,
    default: false,
  },
  isCustomItem: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  resultShow: {
    type: Boolean,
    default: true,
  },
  joinGroup: {
    type: Boolean,
    default: false
  }
},
  emits: ['search', 'submit', 'cancel'],
  setup(__props, { emit }) {

const props = __props



const type = ref('');
const transferList = ref([]);
const transferSelectedList = ref([]);
const isTransferSearch = ref(true);
const isTransferCustomItem = ref(false);
const transferTitle = ref('');
const searchValue = ref('');
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");


watchEffect(() => {
  if (props.isCustomItem) {
    for (let index = 0; index < props.list.length; index++) {
      if ((props.list[index] as any).conversationID.indexOf('@TIM#SYSTEM') > -1) {
        props.list.splice(index, 1);
      }
      transferList.value = props.list;
    }
  } else {
    transferList.value = props.list;
  }
  transferSelectedList.value = props.selectedList;
  isTransferSearch.value = props.isSearch;
  isTransferCustomItem.value = props.isCustomItem;
  transferTitle.value = props.title;
  type.value = props.type;
});




// 可选项
const optional = computed(() => transferList.value.filter((item: any) => !item.isDisabled));

const handleInput = (e: any) => {
  searchValue.value = e.target.value;
  emit('search', e.target.value);
};
const selected = (item: any) => {
  if (item.isDisabled) {
    return;
  }
  let list: Array<[]> = transferSelectedList.value;
  const index: number = list.indexOf(item);
  if (index > -1) {
    return transferSelectedList.value.splice(index, 1);
  }
  if (props.isRadio) {
    list = [];
  }
  list.push(item);
  transferSelectedList.value = list;
};

const selectedAll = () => {
  if (transferSelectedList.value.length === optional.value.length) {
    transferSelectedList.value = [];
  } else {
    transferSelectedList.value = [...optional.value];
  }
};

const submit = () => {
  emit('submit', transferSelectedList.value);
  // 针对小程序做的数据清空
  searchValue.value = "";
};

const cancel = () => {
  emit('cancel');
  // 针对小程序做的数据清空
  searchValue.value = "";
};

return { __sfc: true,props, type, transferList, transferSelectedList, isTransferSearch, isTransferCustomItem, transferTitle, searchValue, isPC, isUniFrameWork, isWeChat, emit, optional, handleInput, selected, selectedAll, submit, cancel, TUITranslateService, Icon, selectedIcon, backIcon, cancelIcon }
}

})